import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightConfigureRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-configure',
	path: '/jira/servicedesk/insight/configure',
};
